<template>
    <div class="wapOfficial">
        <div class="banner">
            <img src="@/assets/zkjyOfficial/banner-image.png" alt="" class="banner-image">
        </div>

        <div class="intro">
            <h1 class="intro-title"></h1>
            <div class="intro-text-box">
                <p class="intro-text"><span class="spot"></span>北京中科基因技术股份有限公司系动物疫病检测独立实验室连锁机构，为养殖企业提供疫病诊断、基因测序、免疫效果评价服务；</p>
            </div>
            <div class="intro-text-box">
                <p class="intro-text"><span class="spot"></span>中科名兽医APP是其主导开发的一款集线上兽医咨询、动物疫病诊断、线上基因检测、兽医在线继续教育、动物健康管理等功能的兽医领域共享APP平台。</p>
            </div>
        </div>
        <div class="intro" style="margin-top:-7.8vw">
            <h1 class="intro-title-service"></h1>
            <div class="intro-form">
                <van-form style="width: 100%;">
                    <div class="intro-form-item">
                        <img src="../../assets/zkjyOfficial/iphone.png"/>
                        <van-field v-model="introMobile" name="introMobile" type="tel" maxlength="11" placeholder="请输入您的手机号"/>
                        <strong>*</strong>
                    </div>
                    <div class="intro-form-item">
                        <img src="../../assets/zkjyOfficial/phone-code.png"/>
                        <van-field v-model="introCode" name="introCode" type="tel" maxlength="6" placeholder="请输入您的手机验证码" style="width: initial;"/>
                        <button class="sendCode" :style="{'color':codeStatus ? '#999999':'','background-color':codeStatus ?'#f7f7f7':''}" :disabled="codeStatus" @click="sendCode">{{codeText}}</button>
                        <strong>*</strong>
                    </div>
                    <div class="submit-btn">
                        <van-button round block native-type="submit" :disabled="submitStatus" @click="onSubmitIntro">立即领取</van-button>
                    </div>
                    <div class="tips">
                        <div><van-checkbox v-model="introChecked"></van-checkbox></div>
                        <p>我同意通过电话、短信、或其他电子方式接收中科名兽医的产品内容和服务信息。</p>
                    </div>
                </van-form>
            </div>
        </div>

        <div class="section" style="padding-bottom:6.93vw;">
            <h1 class="section-1-title"></h1>
            <p class="section-text">通过线上咨询、与共享专家互动，<br />解决养殖及宠物领域的答疑需求。</p>
            <div class="section-images">
                <img src="@/assets/zkjyOfficial/section-1-image.png" alt="" class="section-1-image">
            </div>
        </div>

        <div class="section white_bg">
            <h1 class="section-2-title"></h1>
            <p class="section-text">通过线上查询档案和地图的方式搜索附近的兽医，<br />以图文留言、预约出诊等方式解决用户的兽医需求。</p>
            <div class="section-images">
                <img src="@/assets/zkjyOfficial/section-2-image.png" alt="" class="section-2-image">
            </div>
        </div>

        <div class="section">
            <h1 class="section-3-title"></h1>
            <p class="section-text">通过线上下单和线下送样，及时解决用户检测需求，<br />检测完成可直接线上查看检测报告。</p>
            <div class="section-images">
                <img src="@/assets/zkjyOfficial/section-3-image.png" alt="" class="section-3-image">
            </div>
        </div>

        <div class="section white_bg">
            <h1 class="section-4-title"></h1>
            <p class="section-text">每周定时邀请行业大咖，线上直播答疑，<br />中科课堂还提供了往期录制的精品养殖课程，<br />为您答惑解疑，在线学习。</p>
            <div class="section-images">
                <img src="@/assets/zkjyOfficial/section-4-image.png" alt="" class="section-4-image">
            </div>
        </div>

        <div class="us-information">
            <div class="contact-us">
                <h1 class="us-title"></h1>
                <div class="us-intro white_bg">
                    <div class="us-intro-text">有任何养殖或养宠物的问题都可在此平台咨询。我们将继续优化产品，提高平台服务体验，敬请关注。</div>
                    <div class="contact-mode" style="padding-top:1.87vw">
                        <span class="spot"></span>
                        <p>联系电话：010-62142951</p>
                    </div>
                    <div class="contact-mode" style="padding: 2.67vw 0 4vw;">
                        <span class="spot"></span>
                        <b @click="openWebsite">中科基因官方网址：http://www.sslab.com.cn/</b>
                    </div>
                    <div class="contarct-code">
                        <div class="code-image-box"><img src="@/assets/zkjyOfficial/contact-code.png" class="code-image"/></div>
                        <div class="contact-text">扫描二维码进入<br />中科基因微信订阅号</div>
                    </div>
                </div>
            </div>

            <div class="submit-form white_bg">
                <h1 class="form-title"></h1>
                <van-form @submit="onSubmit" style="width: 100%;">
                    <van-field v-model="customerName" name="姓名" label="姓名" required placeholder="姓名"/>
                    <van-field v-model="customerMobile" type="tel" name="手机" label="手机" required maxlength="11" placeholder="手机"/>
                    <van-field readonly clickable required name="question" :value="question" label="类型" placeholder="请点击选择您的问题" @click="showPicker = true"/>
                        <van-icon name="arrow-down" />
                        <van-popup v-model="showPicker" position="bottom">
                            <van-picker show-toolbar :columns="columns" @confirm="onConfirm" @cancel="showPicker = false"/>
                        </van-popup>
                    <van-field v-model="leavMessage" type="textarea" name="留言" rows="2" autosize label="留言" placeholder="请将您想了解的告知我们"/>
                    <div class="tips">
                        <div><van-checkbox v-model="checked"></van-checkbox></div>
                        <p>我同意通过电话、短信、或其他电子方式接收中科名兽医的产品内容和服务信息。</p>
                    </div>
                    <div class="submit-btn">
                        <van-button round block native-type="submit"></van-button>
                    </div>
                </van-form>
            </div>
        </div>

        <div class="foot-box">
            <span>京ICP备16030979号-1 <br />版权所有：北京中科基因技术股份有限公司</span>
        </div>
    </div>
</template>
<script>
import { Notify, Toast } from 'vant';
import * as  API_ from '@/api/resetApi.js'
export default {
    components: {
        [Notify.Component.name]: Notify.Component,
    },
    data(){
        return {
            customerName: '',
            customerMobile: '',
            leavMessage:'',
            questionNum:'',
            question:'',
            checked:false,
            columns: ['线上问诊', '动物基因检测', '兽医学习', '其它'],
            showPicker: false,
            introMobile:'',
            introCode:'',
            introChecked:false,
            codeText:'发送验证码',
            countDown: 60,
            codeStatus:false,
            timer:null,
            submitStatus:false
        }
    },
    created () {
        
    },
    mounted(){

    },
    methods:{
        countDowns(){
            this.timer = setInterval(()=>{
                this.countDown --
                if(this.countDown<0){
                    clearInterval(this.timer);
                    this.countDown = 60
                    this.codeText = '重新发送'
                    this.codeStatus = false
                }else{
                    this.codeStatus = true
                    this.codeText = this.countDown+'s'
                }
            },1000)
        },
        async sendCode(){
            const re = /^1(3|4|5|6|7|8|9)\d{9}$/
            if(!this.introMobile){
                return Toast('手机号不能为空')
            } else if(!re.test(this.introMobile)){
                return Toast('请填写正确的手机格式')
            }else{
                this.countDowns()
                const data = {
                    cuPhone:this.introMobile,
                    sysCode:'zkmsy',
                    cpmType: 1
                }
                try {
                    const res = await API_.getSmsCode(data)
                    if(res.data.code == 200){
                        Toast.success('发送成功')
                    }else if(res.data.code == 0){
                        Toast.success('只能领取一次')
                        clearInterval(this.timer);
                        this.countDown = 60
                        this.codeStatus = true
                    }else{
                        Toast('发送失败')
                        clearInterval(this.timer);
                        this.countDown = 60
                        this.codeText = '重新发送'
                        this.codeStatus = false
                    }
                } catch (error) {
                    
                }
            }
            
        },
        async login(){
            const data = {
                cuPhone: this.introMobile,
                msgCode: this.introCode
            }
            try {
                const res = await API_.getZkmsyPhonelogin(data)
                if(res.data.code == 200){
                    this.submitStatus = true
                    Toast.success('领取成功')
                }else{
                    Toast('领取失败')
                }
            } catch (error) {
                
            }
        },
        openApp(){
            window.location = 'http://t.cn/Aijv8II4'
        },
        openWebsite(){
            window.location = 'https://www.sslab.com.cn/'
        },
        async leavingMessageAdd(){
            const data = {
               customerName:this.customerName,
               customerMobile:this.customerMobile,
               questionNum:this.questionNum,
               leavMessage:this.leavMessage
            }
            try {
                let res = await API_.leavingMessageAdd(data)
                if(res.data.code === 200){
                    Toast.success('提交成功')
                }else{
                    Toast.fail(res.data.msg)
                }
            } catch (error) {
                
            }
        },
        onSubmit(values) {
            const re = /^1(3|4|5|6|7|8|9)\d{9}$/
            if(!this.customerName){
                return Toast('姓名不能为空')
            }else if(!this.customerMobile){
                return Toast('手机号不能为空')
            } else if(!re.test(this.customerMobile)){
                return Toast('请填写正确的手机格式')
            } else if(!this.question){
                return Toast('请点击选择您的问题')
            }else if(!this.checked){
                return Toast('请勾选用户须知')
            } else{
                if(values.question === '线上问诊'){
                    this.questionNum = 1
                }else if(values.question === '动物基因检测'){
                    this.questionNum = 2
                } else if(values.question === '兽医学习'){
                    this.questionNum = 3
                } else if(values.question === '其它'){
                    this.questionNum = 4
                }
                this.leavingMessageAdd()
            }
        },
        onSubmitIntro(values){
            const re = /^1(3|4|5|6|7|8|9)\d{9}$/
            if(!this.introMobile){
                return Toast('手机号不能为空')
            } else if(!re.test(this.introMobile)){
                return Toast('请填写正确的手机格式')
            }else if(!this.introCode){
                return Toast('验证码不能为空')
            }else if(!this.introChecked){
                return Toast('请勾选用户须知')
            } else{
                this.login()
            }
        },
        onConfirm(value) {
            this.question = value;
            this.showPicker = false;
        }
    }
}
</script>
<style scoped>
.wapOfficial .submit-form .van-field__label{
    color: #333333;
    font-size: 0.16rem;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    text-align: right;
    line-height: 12.8vw;
    width: 8.8vw;
    margin-right:3.5vw;
}
.wapOfficial .submit-form .van-cell::after{
    border: none;
}
.wapOfficial .submit-form .van-field__value{
    min-height: 12.8vw;
    opacity: 1;
    background: #ffffff;
    border: 0.27vw solid #e8e8e8;
    border-radius: 1.6vw;
    line-height: 12.8vw;
    padding-left: 0.14rem;
}
.wapOfficial .submit-form .van-cell--required::before{
    line-height: 12.8vw;
    font-size: 0.14rem;
    left: 8.5vw;
}
.wapOfficial .submit-form .van-cell{
    padding: 0;
    margin-bottom: 3.2vw;
}
.wapOfficial .submit-form .van-field__control{
    font-size: 0.14rem;
}
.wapOfficial .submit-form .van-button--default{
    width: 77.33vw;
    height: 17.33vw;
    background-image: url("~@/assets/zkjyOfficial/form-submit-btn.png");
    background-size: contain;
    background-repeat: no-repeat;
    border: none;
}
.wapOfficial .intro .van-button--default{
    opacity: 1;
    background: linear-gradient(315deg,#096fcb, #2784f8);
    border-radius: 5.87vw;
    backdrop-filter: blur(2.67vw);
    width: 81.6vw;
    height: 11.73vw;
    font-size: 0.18rem;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    text-align: center;
    color: #ffffff;
}
.wapOfficial .intro .van-cell{
    font-size: 0.16rem;
    padding: 0;
    height: 17.6vw;
    line-height: 17.6vw;
}
.wapOfficial .intro .van-cell::after{
    border: none;
}
.wapOfficial .van-button::before{
    background-color: transparent;
}
.wapOfficial .van-checkbox__icon .van-icon{
    width: 4.27vw;
    height: 4.27vw;
    line-height: 4.27vw;
    font-size: 0.6em !important;
}
</style>
<style lang="scss" scoped>
.wapOfficial{
    background-color: #f8f8f8;
}

.white_bg{
    background-color: white;
}

.banner {
    width: 100vw;
    height: 152.53vw;
    font-size: 0;
    .banner-image {
        width: 100%;
        height: 100%;
    }
}

.intro {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    margin: -80px 15px 43px;
    border-radius: 8px;
    padding: 22px 0 16px;
    background-color: #fff;
    box-shadow: 0px 2px 2px 0px rgba(244,244,244,0.83);
    .intro-form{
        padding: 3.2vw 5.33vw 0;
        .intro-form-item{
            display: flex;
            height: 17.6vw;
            align-items: center;
            opacity: 1;
            border-bottom: 0.27vw solid #f5f5f5;
            img{
                width: 4.8vw;
                height: 4.8vw;
                margin-right: 2.67vw;
            }
            strong{
                opacity: 1;
                font-size: 0.14rem;
                font-family: PingFangSC, PingFangSC-Regular;
                font-weight: 400;
                text-align: left;
                color: #f14f4c;
                line-height: 1.43;
                margin-left: 1.6vw;
            }
            .sendCode{
                width: 23vw;
                height: 8vw;
                opacity: 1;
                background: #0186ff;
                border-radius: 1.07vw;
                font-size: 3.2vw;
                font-family: PingFangSC, PingFangSC-Regular;
                font-weight: 400;
                text-align: center;
                color: #ffffff;
                line-height: 8vw;
                padding: 0;
                margin: 0;
            }
        }
    }
    .intro-title {
        width: 51.2vw;
        height: 4.5vw;
        background-image: url("~@/assets/zkjyOfficial/intro-title.png");
        background-size: contain;
        background-repeat: no-repeat;
    }
    .intro-title-service{
        width: 57.33vw;
        height: 4.8vw;
        background-image: url("~@/assets/zkjyOfficial/service-title.png");
        background-size: contain;
        background-repeat: no-repeat;
    }
    .intro-text-box{
        display: flex;
        align-items: center;
        padding: 0 5.87vw;
    }
    .intro-text {
        font-size: 0.16rem;
        line-height: 1.5;
        text-align: justify;
        color: #444444;
        padding-top: 4.8vw;
        .spot{
            width: 1.07vw;
            height: 1.07vw;
            opacity: 1;
            background: linear-gradient(78deg,#00ff23 0%, #02bbff 94%);
            border-radius: 50%;
            margin-left: 5.33vw;
            margin-right: 2.67vw;
            display: inline-block;
        }
    }
    .tips{
        display: flex;
        padding-top: 3.2vw;
        p{
            padding-left: 3vw;
            opacity: 1;
            font-size: 0.12rem;
            font-family: PingFangSC, PingFangSC-Regular;
            font-weight: 400;
            text-align: left;
            color: #999999;
            line-height: 1.5;
        }
    }
    .submit-btn{
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: 10.13vw;
    }
}

.section {
    display: flex;
    flex-direction: column;
    align-items: center;

    & + .section {
        padding: 10.13vw 0 6.93vw;
    }
    .section-1-title {
        width: 90.4vw;
        height: 9.87vw;
        background-image: url("~@/assets/zkjyOfficial/section-1-title-bg.png");
        background-size: contain;
        background-repeat: no-repeat;
    }
    .section-2-title{
        width: 70.13vw;
        height: 10.67vw;
        background-image: url("~@/assets/zkjyOfficial/section-2-title-bg.png");
        background-size: contain;
        background-repeat: no-repeat;
    }
    .section-3-title{
        width: 84.26vw;
        height: 10.67vw;
        background-image: url("~@/assets/zkjyOfficial/section-3-title-bg.png");
        background-size: contain;
        background-repeat: no-repeat;
    }
    .section-4-title{
        width: 62.13vw;
        height: 10.67vw;
        background-image: url("~@/assets/zkjyOfficial/section-4-title-bg.png");
        background-size: contain;
        background-repeat: no-repeat;
    }
    .section-text {
        margin: 24px 0 30px;
        font-size: 0.14rem;
        line-height: 1.57;
        text-align: center;
    }
    .section-images {
        font-size: 0;
        .section-1-image {
            width: 77.87vw;
        }
        .section-2-image {
            width: 73.87vw;
        }
        .section-3-image {
            width: 77.6vw;
        }
        .section-4-image {
            width: 77.6vw;
        }
    }
}
.us-information{
    background: #275aff;
    padding: 0 4vw 6.67vw;
    font-size: 0;
    .contact-us{
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: 15.2vw;
        margin-bottom: 5.33vw;
        .us-title{
            display: block;
            width: 56.53vw;
            height: 10.67vw;
            background-image: url("~@/assets/zkjyOfficial/us-title.png");
            background-size: contain;
            background-repeat: no-repeat; 
            padding-bottom: 5.6vw;
        }
        .us-intro{
            border-radius: 2.13vw;
            padding: 5.87vw 5.33vw;
            .us-intro-text{
                font-size: 0.14rem;
                line-height: 1.57;
                text-align: justify;
                text-indent: 0.28rem;
                padding-bottom: 5.33vw;
                border-bottom: 1px dashed #F5F5F5;
            }
            .contact-mode{
                display: flex;
                align-items: center;
                span{
                    width: 1.07vw;
                    height: 1.07vw;
                    opacity: 1;
                    background: linear-gradient(78deg,#00ff23 0%, #02bbff 94%);
                    border-radius: 50%;
                    margin-right: 1.87vw;
                }
                p,b{
                    font-size: 0.13rem;
                    line-height: 1.57;
                    color: #666666;
                    text-align: left;
                    font-family: PingFangSC, PingFang
                }
            }
            .contarct-code{
                display: flex;
                align-items: center;
                .code-image-box{
                    font-size: 0;
                    margin-right: 4vw;
                    .code-image{
                        width: 19.2vw;
                        height: 19.2vw;
                    }
                }
                .contact-text{
                    font-size: 0.16rem;
                    line-height: 1.5;
                    font-weight: 500;
                    text-align: left;
                }
            }
        }
    }
    .submit-form{
        font-size: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 6.93vw 3.93vw 0;
        border-radius: 2.13vw;
        .form-title{
            width: 40.53vw;
            height: 4.53vw;
            background-image: url("~@/assets/zkjyOfficial/form-title.png");
            background-size: contain;
            background-repeat: no-repeat;
            padding-bottom: 6.93vw;
        }
        .tips{
            display: flex;
            p{
                padding-left: 3vw;
                opacity: 1;
                font-size: 0.12rem;
                font-family: PingFangSC, PingFangSC-Regular;
                font-weight: 400;
                text-align: left;
                color: #999999;
                line-height: 1.5;
            }
        }
        .submit-btn{
            display: flex;
            flex-direction: column;
            align-items: center;
        }
    }
}
.foot-box{
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 3.2vw 0;
    background: #eff6ff;
    span{
        opacity: 1;
        font-size: 0.12rem;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        color: #666666;
        line-height: 1.5;
        letter-spacing: 1px;
    }
}
</style>